import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {}

  setCanonicalUrl(url: string): void {
    let canonicalLink = this.document.querySelector("link[rel='canonical']" ) as HTMLLinkElement;

    if (!canonicalLink) {
      canonicalLink = this.document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      this.document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', url);
  }

  removeCanonicalUrl(): void {
    const canonicalLink = this.document.querySelector("link[rel='canonical']");

    if (canonicalLink) {
      canonicalLink.remove();
    }
  }
}